import { CardFilter, Member, SVG } from "ui";
import { usersArray } from "assets/data/usersData";
import { Link } from "react-router-dom";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";

const Following = () => {
    const members = usersArray.filter((member, i) => {
        if (i % 2 == 0) {
            return member;
        }
    });
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        },
        {
            path: "/users",
            text: "Users"
        },
        {
            path: "/Users/5",
            text: "Details"
        }
    ];

    return (
        <section className="w-full h-full flex flex-col relative">
            <div className="w-full h-full flex relative  overflow-auto">
                <div className="w-full flex flex-col">
                    <div className="w-full text-center">
                        <Breadcrumb
                            breadcrumb={breadcrumb}
                            currentPath="Following"
                        />
                    </div>
                    <div className="w-full justify-center items-start flex flex-col flex-wrap gap-10 py-10 px-10 ">
                        <div className="profile-name-container flex flex-col lg:flex-row justify-between items-center gap-5 w-full">
                            <div className="flex justify-start items-center gap-2">
                                <Link to="/communities/view/1">
                                    <SVG svg="arrow-left" size={24} />
                                </Link>
                                <div className="flex flex-col gap-2 justify-start items-start">
                                    <h2 className="font-bold text-2xl text-black dark:text-white">
                                        Full Name
                                    </h2>
                                    <span className="dark:text-white">
                                        @userName
                                    </span>
                                </div>
                            </div>
                            <div>
                                <CardFilter
                                    dropDownItems={[
                                        "By Full Name",
                                        "By User ID",
                                        "By About Me",
                                        "By Country",
                                        "By Topics"
                                    ]}
                                    showFullTitle
                                />
                            </div>
                        </div>
                        <div className="w-full shadow-md bg-neutral-100 dark:bg-momeento-300 rounded">
                            <ul className="profile-followers-tabs-ul w-full flex justify-between items-center dark:text-white">
                                <li
                                    className={`profile-followers-tabs-li cursor-pointer`}
                                >
                                    <Link
                                        to={`/users/view/1/followers`}
                                        className="w-full block"
                                    >
                                        Followers
                                    </Link>
                                </li>
                                <li
                                    id="incident-tab-li"
                                    className={`is-active profile-followers-tabs-li cursor-pointer`}
                                >
                                    <Link
                                        to={`/users/view/1/following`}
                                        className="w-full block"
                                    >
                                        Following
                                    </Link>
                                </li>
                            </ul>

                            {/* members panel */}
                            <div
                                className={` profile-followers-container p-5 flex flex-col justify-between`}
                            >
                                <div>
                                    {members.map((member) => (
                                        <Member user={member} key={member.id} />
                                    ))}
                                    {members.map((member) => (
                                        <Member user={member} key={member.id} />
                                    ))}
                                </div>
                                <div className="mb-3 flex justify-center w-full">
                                    {/* <Button text="show More" color="" rounded /> */}
                                    <button className="rounded-full bg-momeento-50 text-white px-3 py-1">
                                        Show More
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Following;
